<template>
  <div
    class="bet-placed-chip"
    :class="[
      `bet-placed-chip--${placement}`,
      { 'bet-placed-chip--overlap': overlap },
    ]"
  >
    <img class="bet-placed-chip__image" :src="chipImageSrc" alt="" />
    <span class="bet-placed-chip__value" :class="valueClass">{{ chipLabel }}</span>
  </div>
</template>

<script>
export default {
  props: {
    amount: {
      type: Number,
      required: true,
    },
    placement: {
      type: String,
      default: 'center',
      validator: (value) => ['top-left', 'top-right', 'center'].includes(value),
    },
    chips: {
      type: Array,
      default: () => [],
    },
    overlap: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    chipColor() {
      const colors = ['blue', 'orange', 'black', 'purple', 'yellow'];
      const chips = this.chips.map(Number).filter((chip) => chip > 0);

      if (!chips.length) {
        return 'blue';
      }

      const amount = Number(this.amount);
      const exactIndex = chips.findIndex((chip) => chip === amount);

      if (exactIndex >= 0) {
        return colors[exactIndex] || 'blue';
      }

      let index = 0;

      chips.forEach((chip, chipIndex) => {
        if (amount >= chip) {
          index = chipIndex;
        }
      });

      return colors[index] || 'blue';
    },
    chipImageSrc() {
      return require(`@/assets/svg/chips/${this.chipColor}.svg`);
    },
    chipLabel() {
      const value = Number(this.amount);

      if (value >= 1e6) {
        return Number.isInteger(value / 1e6) ? `${value / 1e6}M` : `${(Math.floor(value / 1e5) / 10).toFixed(1)}M`;
      }

      if (value >= 10000) {
        return Number.isInteger(value / 1000) ? `${value / 1000}K` : `${(Math.floor(value / 100) / 10).toFixed(1)}K`;
      }

      return String(value);
    },
    valueClass() {
      const length = this.chipLabel.length;

      if (length >= 4) return 'f-8';
      if (length === 3) return 'f-9';
      if (length === 2) return 'f-11';

      return 'f-12';
    },
  },
};
</script>

<style lang="scss" scoped>
.bet-placed-chip {
  position: absolute;
  z-index: 2;
  width: 32px;
  height: 32px;
  pointer-events: none;

  &--top-left {
    top: 2px;
    left: 2px;
  }

  &--top-right {
    top: 2px;
    right: 2px;

    &.bet-placed-chip--overlap {
      top: 3px;
      right: 3px;
      width: 20px;
      height: 20px;
    }
  }

  &--center {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.bet-placed-chip__image {
  width: 100%;
  height: 100%;
  display: block;
}

.bet-placed-chip__value {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-weight: 600;
  line-height: 1;
  text-shadow: 0 0 5px rgba(88, 88, 88, 0.9);
  white-space: nowrap;

  &.f-8 {
    font-size: 8px;
  }

  &.f-9 {
    font-size: 9px;
  }

  &.f-11 {
    font-size: 11px;
  }

  &.f-12 {
    font-size: 12px;
  }
}
</style>
